<template>
  <v-row class="ma-8 pt-8">
    <v-col
      v-if="reportsInstance && reportsInstance.getReports().length"
      class="col-2"
    >
      <v-card outlined>
        <v-card-text class="pb-0">
          <v-row>
            <v-col class="col-12 pb-0">
              <s-date-picker
                :date.sync="date"
                :label="$t('booking.selectDate')"
                :rules="[]"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- reports -->
    <v-col v-if="reportsInstance" class="col-10 pt-0">
      <v-row>
        <!-- iterate all reports -->
        <v-col
          v-for="(report, reportIndex) in reportsInstance.getReports()"
          :key="reportIndex"
          class="col-4"
        >
          <v-card
            hover
            class="clickable"
            @click="
              $router.push({
                name: 'singleReport',
                params: { report: report, date: date },
              })
            "
          >
            <v-card-title>
              <h2 class="wordbreak">{{ report.getTitle() }}</h2>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <!--- Excel Exports --->
    <v-col
      v-if="bookingExcelExporter && isCurrentUserAllowedToExport"
      class="col-10 pt-0 offset-2"
    >
      <accounting-export :booking-excel-exporter="bookingExcelExporter" />
    </v-col>
  </v-row>
</template>

<script>
import SDatePicker from '../../../components-shared/utils/SDatePicker'
import moment from 'moment'
import Reports from '../../../classes-internal/reports/Reports'
import BookingExcelExport from '../../../classes-internal/reports/BookingExcelExport'
import AccountingExport from './AccountingExport'
import store from '../../../store/store'
import definitions from '../../../../definitions'

export default {
  name: 'ReportsOverview',
  components: { AccountingExport, SDatePicker },

  data() {
    return {
      date: null,
      // Type: Reports
      reportsInstance: new Reports(),
      bookingExcelExporter: new BookingExcelExport(),
    }
  },

  asyncComputed: {
    /**
     * check if the current user is allowed to generate the accounting export
     * @returns Boolean
     */
    async isCurrentUserAllowedToExport() {
      let appUser = store.getters.getAppUserInstance()
      return await appUser?.doIHavePermissionInTheCurrentDestinationForKey(
        definitions.permissions.shopApi.BOOKING_EXPORT_ACCOUNTING
      )
    },
  },

  beforeMount() {
    // get date from route
    if (this.$route.params.date) this.date = this.$route.params.date
    else this.date = moment().format('YYYY-MM-DD')

    // load reports
    this.reportsInstance.initReports(
      this.$store.getters.getCurrentDestinationInstance().getSlug()
    )
  },
}
</script>

<style lang="scss">
.v-divider {
  color: var(--v-secondary-lighten5) !important;
}

.wordbreak {
  word-break: break-word;
}
</style>
